import { set_dimensions } from "../../services/global.services";

var footer_styles = function (app_dimensions: any) {
  return {
    footer_container: {
      display: "flex" as const,
      flexWrap: "wrap" as const, // allows content to wrap on smaller screens
      alignItems: "center" as const,
      width: "100%",
      // maxWidth: app_dimensions.desktop ? "97%" : "92vw", // ensures no overflow beyond viewport
      // padding: app_dimensions.desktop ? "16px 32px" : "0px 16px 0px 16px", // reduced padding for better mobile behavior
      // margin: "0 auto", // centers inner content if inside a full-width container
      borderTop: "1px solid #E8E9EB",
      backgroundColor: "#F7F7F7",
      position: "fixed" as const,
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 1000 as const,
      padding: app_dimensions.desktop ? "0.5rem 2rem 0.5em 2rem" : "0.5rem 0 0.5em 0",
      // textAlign: !app_dimensions.desktop ? "center" as const : "center" as const,
    },
    buttons: {
      display: "flex",
      // width: "654px",
      // alignItems: "center",
      justifyContent: "flex-start",
      gap: "8px",
      flexShrink: 0,
    },
    link: {
      color: "var(--Gray---800, #4F5467)",
      fontFamily: "Montserrat",
      fontSize: "13px",
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: "16px",
    },
    link_text: {
      color: "var(--Black---1000, #191924)",
      fontFamily: "Montserrat",
      fontSize: "13px",
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: "16px",
      textDecorationLine: "underline",
      textDecorationStyle: "solid" as const,
      textDecorationSkipInk: "none" as const,
      textDecorationThickness: "auto" as const,
      textUnderlineOffset: "auto" as const,
      textUnderlinePosition: "from-font" as const,
    },
    br: {
      display: "flex",
      width: "5px",
      height: "20px",
      flexDirection: "column",
      justifyContent: "center",
      flexShrink: 0,
      color: "var(--Gray---800, #4F5467)",
      fontFamily: "Montserrat",
      fontSize: "12px",
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: "16px",
    },
  };
};

export default footer_styles;